<template>
    <Modal ref="modalRef" :name="name" max-width="lg">
        <template #title>
            <div class="-mx-8 -my-4 bg-[#002377] px-8 py-4 text-white">
                <h3 class="text-lg !leading-normal font-bold">{{ title }}</h3>
            </div>
        </template>

        <slot />

        <template #footer>
            <jet-button style="flex: 1" type="button" variant="secondary" @click.stop="onCancel">{{ resolvedCancelText }}</jet-button>
            <jet-button style="flex: 1" type="button" variant="primary" @click.stop="onConfirm">{{ resolvedConfirmText }}</jet-button>
        </template>
    </Modal>
</template>

<script setup>
import JetButton from '@/Jetstream/Button.vue';
import { computed, ref } from 'vue';
import Modal from '@/Components/Modal.vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    name: {
        type: String,
        default: 'confirm-cancel',
    },
    title: {
        type: String,
        required: true,
    },
    cancelText: {
        type: String,
    },
    confirmText: {
        type: String,
    },
});

const emit = defineEmits(['cancel', 'confirm']);
const modalRef = ref(null);
const resolvedCancelText = computed(() => {
    return props.cancelText || trans('general.action.cancel');
});
const resolvedConfirmText = computed(() => {
    return props.confirmText || trans('general.action.confirm');
});

function onConfirm() {
    modalRef.value?.close();
    emit('confirm');
}
function onCancel() {
    modalRef.value?.close();
    emit('cancel');
}
</script>
